
import Component from "vue-class-component"
import PageHeader from "@/superannuation/PageHeader.vue"
import HelpIcon from "@/ui/HelpIcon.vue"
import Vue from "vue"
import SelectDropDown from "@/components/SelectDropDown.vue"
import {QPopupProxy} from "quasar"
import Axios, {AxiosError, AxiosResponse} from "axios"

@Component({
  components: {
    SelectDropDown,
    PageHeader,
    HelpIcon,
    QPopupProxy,
  },
})
export default class DevelopmentOpsView extends Vue {
  jobs: Array<Record<string, unknown>> = new Array<Record<string, unknown>>()
  nodes: Array<Record<string, unknown>> = new Array<Record<string, unknown>>()
  alerts: Array<Record<string, unknown>> = new Array<Record<string, unknown>>()

  selected: string | null = null

  message: string | null = null

  dataInProgress = false

  async created() {
    await this.getBatchJobTree()
    await this.getNodeContainerTree()
    await this.getMonitorAlertTree()
  }

  private async refresh(done: () => void) {
    await this.getBatchJobTree()
    await this.getNodeContainerTree()
    await this.getMonitorAlertTree()
    done()
  }

  private async getBatchJobTree() {
    this.dataInProgress = true
    await Axios.get(`/api/devops/batches`)
      .then((response: AxiosResponse) => {
        this.message = null
        this.jobs = response.data
      })
      .catch((reason: AxiosError<any>) => {
        this.message = reason.response?.data.message
      })
      .finally(() => (this.dataInProgress = false))
  }

  private async getNodeContainerTree() {
    this.dataInProgress = true
    await Axios.get(`/api/devops/containers/tree`)
      .then((response: AxiosResponse) => {
        this.message = null
        this.nodes = response.data
      })
      .catch((reason: AxiosError<any>) => {
        this.message = reason.response?.data.message
      })
      .finally(() => (this.dataInProgress = false))
  }

  private async getMonitorAlertTree() {
    this.dataInProgress = true
    await Axios.get(`/api/devops/monitors/tree`)
      .then((response: AxiosResponse) => {
        this.message = null
        this.alerts = response.data
      })
      .catch((reason: AxiosError<any>) => {
        this.message = reason.response?.data.message
      })
      .finally(() => (this.dataInProgress = false))
  }
}
